import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { ContactForm } from "./-components/form/contact-form"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/contacts/create",
)({
  staticData: { breadcrumb: "New contact" },
  component: CreateContactPage,
})

function CreateContactPage(): React.ReactElement {
  const { customerId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <PageContent>
        <PageTitle title="New contact" />
        <Card className="p-4 shadow-none">
          <ContactForm
            customerId={customerId}
            onCreate={(created) => {
              showToast(
                "Created",
                `${created.first_name} ${created.last_name} added.`,
                "success",
              )
              navigate({
                to: "/customer/$customerId/contacts",
                params: { customerId },
              })
            }}
          />
        </Card>
      </PageContent>
    </div>
  )
}
